"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.locations = exports.colors = exports.marker_colors = exports.mapbox_token = exports.USACentered = void 0;
exports.USACentered = [-98.5556199, 39.8097343];
exports.mapbox_token = 'pk.eyJ1IjoiYnJhbmRvbmxlaG1hbm4iLCJhIjoiY204ejBkbjByMDZzajJrb2h0eTVsZGNvdCJ9.Z3mzI4Qz_cnMGhI38IDiaQ';
exports.marker_colors = {
    office: '#349946',
    hourly: '#387dc0',
    salaried: '#26498d',
    employee: '#f3703c'
};
exports.colors = [
    '#1a9641', // dark green
    '#51b36a', // green
    '#a6d96a', // light green
    '#d3ec95', // very light green
    '#ffffbf', // pale yellow
    '#fee08b', // light orange
    '#fdae61', // orange
    '#f46d43', // dark orange
    '#d53e4f', // red
    '#b30000' // dark red
];
exports.locations = [{
        id: 1,
        name: 'Holland, OH - HQ',
        lat: 41.6118821,
        lng: -83.7072577
    }, {
        id: 2,
        name: 'Mooresville, NC',
        lat: 35.5998366,
        lng: -80.8581337
    }, {
        id: 3,
        name: 'Holland, OH - Warehouse',
        lat: 41.5962394,
        lng: -83.8175622
    }, {
        id: 4,
        name: 'Dallas, TX',
        lat: 32.7939118,
        lng: -96.8058829
    }, {
        id: 5,
        name: 'Kansas City, MO',
        lat: 38.9543773,
        lng: -94.6626359
    }];
